import * as types from './types';

export const activateMfaRequest = (data) => ({ type: types.ACTIVATE_MFA_REQUEST, data });
export const activateMfaRequestFailure = (error) => ({ type: types.ACTIVATE_MFA_REQUEST_FAILURE, error });
export const activateMfaRequestSuccess = (data) => ({ type: types.ACTIVATE_MFA_REQUEST_SUCCESS, data });

export const deactivateMfaRequest = (data) => ({ type: types.DEACTIVATE_MFA_REQUEST, data });
export const deactivateMfaRequestFailure = (error) => ({ type: types.DEACTIVATE_MFA_REQUEST_FAILURE, error });
export const deactivateMfaRequestSuccess = (data) => ({ type: types.DEACTIVATE_MFA_REQUEST_SUCCESS, data });

export const forgotPasswordRequest = (data) => ({ type: types.FORGOT_PASSWORD_REQUEST, data });
export const forgotPasswordRequestFailure = (error) => ({ type: types.FORGOT_PASSWORD_REQUEST_FAILURE, error });
export const forgotPasswordRequestSuccess = (data) => ({ type: types.FORGOT_PASSWORD_REQUEST_SUCCESS, data });

export const getUserRequest = (data) => ({ type: types.GET_USER_REQUEST, data });
export const getUserRequestFailure = (error) => ({ type: types.GET_USER_REQUEST_FAILURE, error });
export const getUserRequestSuccess = (data) => ({ type: types.GET_USER_REQUEST_SUCCESS, data });

export const loginRequest = (data) => ({ type: types.LOGIN_REQUEST, data });
export const loginRequestFailure = (error) => ({ type: types.LOGIN_REQUEST_FAILURE, error });
export const loginRequestSuccess = (data) => ({ type: types.LOGIN_REQUEST_SUCCESS, data });

export const logoutRequest = (data) => ({ type: types.LOGOUT_REQUEST, data });
export const logoutRequestFailure = (data) => ({ type: types.LOGOUT_REQUEST_FAILURE, data });
export const logoutRequestSuccess = (data) => ({ type: types.LOGOUT_REQUEST_SUCCESS, data });

export const protectionPwdRequest = (data) => ({ type: types.PROTECTION_PWD_REQUEST, data });
export const protectionPwdRequestFailure = (error) => ({ type: types.PROTECTION_PWD_REQUEST_FAILURE, error });
export const protectionPwdRequestSuccess = (data) => ({ type: types.PROTECTION_PWD_REQUEST_SUCCESS, data });

export const registerRequest = (data) => ({ type: types.REGISTER_REQUEST, data });
export const registerRequestFailure = (error) => ({ type: types.REGISTER_REQUEST_FAILURE, error });
export const registerRequestSuccess = (data) => ({ type: types.REGISTER_REQUEST_SUCCESS, data });
export const registerSetSubmitted = (data) => ({ type: types.REGISTER_SET_SUBMITTED, data });

export const registerResendEmailRequest = (data) => ({ type: types.REGISTER_RESEND_EMAIL_REQUEST, data });
export const registerResendEmailRequestFailure = (error) => ({ type: types.REGISTER_RESEND_EMAIL_REQUEST_FAILURE, error });
export const registerResendEmailRequestSuccess = (data) => ({ type: types.REGISTER_RESEND_EMAIL_REQUEST_SUCCESS, data });

export const registerEmployeeRequest = (data) => ({ type: types.REGISTER_EMPLOYEE_REQUEST, data });
export const registerEmployeeRequestFailure = (error) => ({ type: types.REGISTER_EMPLOYEE_REQUEST_FAILURE, error });
export const registerEmployeeRequestSuccess = (data) => ({ type: types.REGISTER_EMPLOYEE_REQUEST_SUCCESS, data });

export const resetPasswordRequest = (data) => ({ type: types.RESET_PASSWORD_REQUEST, data });
export const resetPasswordRequestFailure = (error) => ({ type: types.RESET_PASSWORD_REQUEST_FAILURE, error });
export const resetPasswordRequestSuccess = (data) => ({ type: types.RESET_PASSWORD_REQUEST_SUCCESS, data });

export const sendFallbackMfaCodeRequest = (data) => ({ type: types.SEND_FALLBACK_MFA_CODE_REQUEST, data });
export const sendFallbackMfaCodeRequestFailure = (error) => ({ type: types.SEND_FALLBACK_MFA_CODE_REQUEST_FAILURE, error });
export const sendFallbackMfaCodeRequestSuccess = (data) => ({ type: types.SEND_FALLBACK_MFA_CODE_REQUEST_SUCCESS, data });

export const resetForgotState = (data) => ({ type: types.RESET_FORGOT_STATE, data });

export const updateAccessToken = (data) => ({ type: types.UPDATE_ACCESS_TOKEN, data });

export const updatePasswordRequest = (data) => ({ type: types.UPDATE_PASSWORD_REQUEST, data });
export const updatePasswordRequestFailure = (error) => ({ type: types.UPDATE_PASSWORD_REQUEST_FAILURE, error });
export const updatePasswordRequestSuccess = (data) => ({ type: types.UPDATE_PASSWORD_REQUEST_SUCCESS, data });

export const updateUserLastActiveTimesheetRequest = (data) => ({ type: types.UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST, data });
export const updateUserLastActiveTimesheetRequestFailure = (error) => ({
  type: types.UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_FAILURE,
  error,
});
export const updateUserLastActiveTimesheetRequestSuccess = (data) => ({
  type: types.UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_SUCCESS,
  data,
});

export const updateUserRequest = (data) => ({ type: types.UPDATE_USER_REQUEST, data });
export const updateUserRequestFailure = (error) => ({ type: types.UPDATE_USER_REQUEST_FAILURE, error });
export const updateUserRequestSuccess = (data) => ({ type: types.UPDATE_USER_REQUEST_SUCCESS, data });

export const validateResetTokenRequest = (data) => ({ type: types.VALIDATE_RESET_TOKEN_REQUEST, data });
export const validateResetTokenRequestFailure = (error) => ({ type: types.VALIDATE_RESET_TOKEN_REQUEST_FAILURE, error });
export const validateResetTokenRequestSuccess = (data) => ({ type: types.VALIDATE_RESET_TOKEN_REQUEST_SUCCESS, data });

export const verifyMfaRequest = (data) => ({ type: types.VERIFY_MFA_REQUEST, data });
export const verifyMfaRequestFailure = (error) => ({ type: types.VERIFY_MFA_REQUEST_FAILURE, error });
export const verifyMfaRequestSuccess = (data) => ({ type: types.VERIFY_MFA_REQUEST_SUCCESS, data });

export const verifyUserRequest = (data) => ({ type: types.VERIFY_USER_REQUEST, data });
export const verifyUserRequestFailure = (error) => ({ type: types.VERIFY_USER_REQUEST_FAILURE, error });
export const verifyUserRequestSuccess = (data) => ({ type: types.VERIFY_USER_REQUEST_SUCCESS, data });
